module.exports = {"data":{"contributionsJson":{"name":"jah","www_url":"http://www.i-love-u.ch","thema":"endstation","issue_month":"August","issue_year":2008,"issue_date":200808,"artist":"admin","location":"Switzerland","email":"response@i-love-u.ch","id":"contribution_437","media_type":"still_image","position_in_section":39,"media_uri":"media/2008/August/still_image/05q.jpg","media_th_uri":"media/2008/August/still_image/tn_01aa.jpg","still_image_count":53,"moving_image_count":1,"textz_count":3,"soundz_count":1}},"pathContext":{"id":"contribution_437"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/issue-200808-still-image-39.json
// module id = 1091
// module chunks = 246450247334503